// Browser translators (Chrome's built-in Google Translate) and some extensions
// rewrite text nodes on the page. React then tries to remove a node, or insert
// next to one, that is no longer where it left it, throws NotFoundError
// ("Failed to execute 'removeChild' on 'Node'") and the whole screen falls into
// the error boundary. On the sign-up page that is a lost registration.
// This is the guard recommended in React issue #11538: when the node has
// already moved, skip the operation instead of throwing.

export function installDomGuard(proto) {
  const target = proto || (typeof Node === 'function' ? Node.prototype : null);
  if (!target || target.__xpDomGuard) return false;
  const originalRemoveChild = target.removeChild;
  target.removeChild = function removeChild(child) {
    if (child && child.parentNode !== this) return child;
    return originalRemoveChild.apply(this, arguments);
  };
  const originalInsertBefore = target.insertBefore;
  target.insertBefore = function insertBefore(newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) return newNode;
    return originalInsertBefore.apply(this, arguments);
  };
  target.__xpDomGuard = true;
  return true;
}

installDomGuard();
